import { Ident } from '@mode-switch/express';
export var Query;
(function (Query) {
    let Type;
    (function (Type) {
        Type["Table"] = "TABLE";
        Type["Pivot"] = "PIVOT";
        Type["Paged"] = "PAGED";
    })(Type = Query.Type || (Query.Type = {}));
    function alias(source, name) {
        return { source, name };
    }
    Query.alias = alias;
    let Table;
    (function (Table) {
        function make(query = {}) {
            const id = Ident.next();
            const name = query.name || id;
            return { id, name, ...query, type: "TABLE" };
        }
        Table.make = make;
        function addField(query, fields) {
            const selections = new Map();
            for (const field of query.fields || []) {
                selections.set(field.formula.source, field);
            }
            for (const field of fields) {
                const source = field.formula.source;
                const hasField = selections.get(source);
                if (hasField) {
                    query = {
                        ...query,
                        aliases: [
                            ...(query.aliases || []),
                            alias(hasField.alias, field.alias),
                        ],
                    };
                }
                else {
                    selections.set(field.formula.source, field);
                    query = { ...query, fields: [...(query.fields || []), field] };
                }
            }
            return query;
        }
        Table.addField = addField;
        function detail(query) {
            var _a, _b;
            return dimensions((_b = (_a = query.detail) !== null && _a !== void 0 ? _a : query.fields) !== null && _b !== void 0 ? _b : []);
        }
        Table.detail = detail;
    })(Table = Query.Table || (Query.Table = {}));
    let Pivot;
    (function (Pivot) {
        function make(query = {}) {
            const id = Ident.next();
            const name = query.name || id;
            return { ...query, id, name, type: "PIVOT" };
        }
        Pivot.make = make;
        function detail(query) {
            var _a, _b, _c, _d, _e, _f;
            return dimensions((_a = query.detail) !== null && _a !== void 0 ? _a : [
                ...((_b = query.column) !== null && _b !== void 0 ? _b : []),
                ...((_c = query.x) !== null && _c !== void 0 ? _c : []),
                ...((_d = query.row) !== null && _d !== void 0 ? _d : []),
                ...((_e = query.y) !== null && _e !== void 0 ? _e : []),
                ...((_f = query.marks) !== null && _f !== void 0 ? _f : []),
            ]);
        }
        Pivot.detail = detail;
    })(Pivot = Query.Pivot || (Query.Pivot = {}));
    let Detail;
    (function (Detail) {
        function get(query) {
            const detail = (() => {
                switch (query.type) {
                    case "TABLE":
                        return Table.detail(query);
                    case "PIVOT":
                        return Pivot.detail(query);
                }
            })();
            if (detail === null || detail === void 0 ? void 0 : detail.length) {
                return detail;
            }
        }
        Detail.get = get;
        function assign(query, detail) {
            detail = dimensions(detail !== null && detail !== void 0 ? detail : []);
            if (detail.length === 0) {
                detail = undefined;
            }
            switch (query.type) {
                case "TABLE":
                case "PIVOT": {
                    detail !== null && detail !== void 0 ? detail : (detail = get(query));
                    if (matches({ ...query, detail })) {
                        detail = undefined;
                    }
                    return {
                        ...query,
                        detail,
                    };
                }
            }
        }
        Detail.assign = assign;
        function extend(target, source) {
            return assign(target, get(source));
        }
        Detail.extend = extend;
        function matches(query) {
            var _a, _b;
            const unsetDetail = (_a = get({ ...query, detail: undefined })) === null || _a === void 0 ? void 0 : _a.map((f) => `${f.name}|${f.formula.source}`).sort();
            const queryDetail = (_b = get(query)) === null || _b === void 0 ? void 0 : _b.map((f) => `${f.name}|${f.formula.source}`).sort();
            if (String(unsetDetail) === String(queryDetail)) {
                return true;
            }
            return false;
        }
        Detail.matches = matches;
    })(Detail = Query.Detail || (Query.Detail = {}));
    function dimensions(fields) {
        return fields.filter((field) => field.role === "DIMENSION" && field.source === "FIELD");
    }
})(Query || (Query = {}));
